import { render, staticRenderFns } from "./LiveProductData.vue?vue&type=template&id=3e4d7991"
import script from "./LiveProductData.vue?vue&type=script&lang=js"
export * from "./LiveProductData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports